import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteAccountingRangeFormModal from 'src/features/accountingRanges/components/forms/DeleteAccountingRangeFormModal';
import { AccountingRange } from 'src/features/accountingRanges/utils/types';
import UpdateAccountingRangeFormModal from 'src/features/accountingRanges/components/forms/UpdateAccountingRangeFormModal';
import { accountingRangesMessages } from 'src/features/accountingRanges/utils/messages';
import { Link } from 'react-router-dom';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

export default function CellAccountingRangeActions({ row }: CellContext<AccountingRange, unknown>) {
    const { formatMessage } = useIntl();
    const permissionManageAccountingRanges = useHasPermissions([PERMISSION.MANAGE_ACCOUNTING_RANGES]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/accounting-ranges/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>
                {permissionManageAccountingRanges && (
                    <>
                        <Tooltip>
                            <UpdateAccountingRangeFormModal
                                semantics={{ entryName: formatMessage(accountingRangesMessages.range).toLowerCase() }}
                                selectedAccountingRange={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateAccountingRangeFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteAccountingRangeFormModal selectedAccountingRange={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteAccountingRangeFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
